// extracted by mini-css-extract-plugin
export var cta = "Hero-module--cta--a504e";
export var intro = "Hero-module--intro--7c36f";
export var subtitle = "Hero-module--subtitle--ec828";
export var text = "Hero-module--text--f755d";
export var title = "Hero-module--title--0f2bd";
export var wrapper = "Hero-module--wrapper--5bad5";